import {
  AppstoreOutlined,
  InfoCircleOutlined,
  LogoutOutlined,
  SettingOutlined,
  ShoppingCartOutlined
} from '@ant-design/icons';
import {useEmotionCss} from '@ant-design/use-emotion-css';
import {history, useModel} from '@umijs/max';
import {Avatar, Badge, Button, Drawer, Form, message, Popover, Space, Spin, Tag} from 'antd';
import type {MenuInfo} from 'rc-menu/lib/interface';
import React, {useCallback, useEffect, useState} from 'react';
import HeaderDropdown from '../HeaderDropdown';
import {ChangePassword} from "@/components/RightContent/ChangePassword";
import {logout, resetPasswordForCurrent} from "@/services/service";
import CustomerModal from './CustomerModal';
import {useSockJsClient} from '../../hooks/useSockJsClient';
import BASEURLCONFIG from "../../../config/BASEURLCONFIG";
import {createStyles} from "antd-style";
import {ContactUtils} from "@/util/ContactUtils";
import PrepareEnv from "@/pages/PrepareEnv";

import icon_customer_service from '../../../public/image/icon_customer_service.svg'
import icon_notice_service from '../../../public/image/icon_notice_service.svg'
import ThemeSelector from "@/components/RightContent/CustomTheme";
import AppDownloadModal from "@/components/RightContent/AppDownloadModal";
import {AppVersionList} from "@/utils/commonDict";

const getRemainingTrialDays = (trialEndTime?: string) => {
  if (!trialEndTime) {
    return 0;
  }
  const endTime = new Date(trialEndTime.replace(/-/g, '/')).getTime();
  if (Number.isNaN(endTime)) {
    return 0;
  }
  const remaining = endTime - Date.now();
  if (remaining <= 0) {
    return 0;
  }
  return Math.ceil(remaining / (24 * 60 * 60 * 1000));
};

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const {initialState} = useModel('@@initialState');
  const {currentUser} = initialState || {};
  return <span className="anticon">{currentUser?.account}</span>;
};

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({menu, children}) => {
  const {initialState, refresh} = useModel('@@initialState');

  const [visible, setVisible] = useState(false);
  const [visibleForCustomer, setVisibleForCustomer] = useState(false);

  const [showMessagePanelFlag, setShowMessagePanelFlag] = useState(false);
  const [appDownloadModalShow, setAppDownloadModalShow] = useState(false);

  // 获取全局状态和方法
  const {messageCount, incrementMessageCount, initMessageCount} = useModel('message');
  const [form] = Form.useForm();
  const {copilotOpen, setCopilotOpen} = useModel('copilot');
  const [showProfileFlag, setShowProfileFlag] = useState(false);

  const useWorkareaStyle = createStyles(({token, css}) => {
    const defaultIconColor = '#333333';
    return {
      copilotWrapper: css`
        min-width: 1000px;
        height: 100vh;
        display: flex;
      `,
      workarea: css`
        flex: 1;
        background: ${token.colorBgLayout};
        display: flex;
        flex-direction: column;
      `,
      workareaHeader: css`
        box-sizing: border-box;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 48px 0 28px;
        border-bottom: 1px solid ${token.colorBorder};
      `,
      headerTitle: css`
        font-weight: 600;
        font-size: 15px;
        color: ${token.colorText};
        display: flex;
        align-items: center;
        gap: 8px;
      `,
      headerButton: css`
        background-image: linear-gradient(78deg, #8054f2 7%, #3895da 95%);
        border-radius: 12px;
        height: 24px;
        width: 93px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;
        font-size: 12px;
        font-weight: 600;
        transition: all 0.3s;

        &:hover {
          opacity: 0.8;
        }
      `,
      workareaBody: css`
        flex: 1;
        padding: 16px;
        background: ${token.colorBgContainer};
        border-radius: 16px;
        min-height: 0;
      `,
      bodyContent: css`
        overflow: auto;
        height: 100%;
        padding-right: 10px;
      `,
      bodyText: css`
        color: ${token.colorText};
        padding: 8px;
      `,
      customerService: css`
        width: 20px;
        height: 20px;
        background-color: ${defaultIconColor};
        mask: url(${icon_customer_service}) no-repeat center;
        mask-size: cover;
        opacity: 0.65;
        &:hover {
          opacity: 1;
        }
      `,
      noticeService: css`
        width: 17px;
        height: 19px;
        background-color: ${defaultIconColor};
        mask: url(${icon_notice_service}) no-repeat center;
        mask-size: cover;
        opacity: 0.6;
        &:hover {
          opacity: 1;
        }
      `,
      trialStatusTag: css`
        margin-right: 0;
        padding: 0 10px;
        border: 1px solid #d98b00;
        border-radius: 12px;
        background: #fff7e6;
        color: #7a3e00;
        font-size: 12px;
        font-weight: 600;
        line-height: 22px;
        white-space: nowrap;
        box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.7);
      `,
    };
  });

  const {styles: workareaStyles} = useWorkareaStyle();

  // 应用加载时初始化
  useEffect(() => {
    // let elements = document.getElementsByClassName('ant-pro-top-nav-header-main');
    // let i;
    // for (i = 0; i < elements.length; i++) {
    //   elements[i].style?.backgroundColor = initialState?.settings?.mainNavColor;
    // }
    // const styleLink: HTMLLinkElement = document.createElement('link');
    // styleLink.id = 'theme';
    // styleLink.rel = 'stylesheet';
    // styleLink.type = 'text/css';
    // document.body.appendChild(styleLink);
    if (initialState?.currentUser?.id) {
      initMessageCount();
    }
  }, []);

// 处理接收到的消息
  const handleMessage = (message: any) => {
    // const body = message.body;
    // console.log(body,'body');
    // setMessages((prev) => [...prev, body]);

    // const content = JSON.parse(message.body);
    // console.log(content.text, 'notice');
    // setMessages((prev) => [...prev, content.text]);
    // incrementMessageCount(1);
    initMessageCount();
  };

  // const headers = {
  //   uid: initialState?.currentUser?.id || '', // 必须确保此处能获取到有效用户 ID
  // };

  // const WS_URL = process.env.NODE_ENV === 'development'
  //   ? BASEURLCONFIG.WS_LOCAL_URL
  //   : location.origin + '/ws';

  // 初始化客户端
  // const {sendMessage} = useSockJsClient({
  //   url: WS_URL,
  //   topics: ['/user/privateTopic/receiveMessage', '/publicTopic/receiveMessage'], // 直接使用固定路径
  //   connectHeaders: headers, // 添加连接头
  //   onMessage: handleMessage,
  //   onConnect: () => console.log('WebSocket Connected!'),
  //   onError: (error) => console.error('WebSocket Error:', error),
  // });

  // 发送消息示例
  // const handleSend = () => {
  //   sendMessage('/app/send-message', { text: 'Hello from React!' });
  // };


  // 发送消息示例
  // const handleSend = () => {
  //   sendMessage('/app/send-message', { text: 'Hello from React!' });
  // };

  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    await logout({});
    const {search, pathname} = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get('redirect');
    // Note: There may be security issues, please note
    if (window.location.pathname !== '/user/login' && !redirect) {
      history.replace({
        pathname: '/user/login',
        search: new URLSearchParams({
          redirect: pathname + search,
        }).toString(),
      });
    }
  };
  const actionClassName = useEmotionCss(({token}) => {
    return {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    };
  });

  const onMenuClick = useCallback(
    async (event: MenuInfo) => {
      const {key} = event;
      if (key === 'logout') {
        localStorage.removeItem('Authorization');
        document.cookie = '';
        await loginOut();
        await refresh();
        return;
      } else if (key === 'orderQuery') {
        history.push('/market/order/order');
      } else if (key === 'center') {
        history.push('/set/info');

      } else if (key === 'changePassword') {
        setVisible(true);
      }
    },
    [initialState],
  );

  // const loading = (
  //   <span className={actionClassName}>
  //     <Spin
  //       size="small"
  //       style={{
  //         marginLeft: 8,
  //         marginRight: 8,
  //       }}
  //     />
  //   </span>
  // );
  //
  // if (!initialState) {
  //   return loading;
  // }

  const {currentUser} = initialState||{currentUser:{}};
  const currentVersionName = initialState?.envInfo?.enterpriseRoleName;
  const trialActive = initialState?.envInfo?.versionTrialStatus === 'TRIALING';
  const trialRemainingDays = getRemainingTrialDays(initialState?.envInfo?.versionTrialEndTime);
  const isFreeVersion =
    (
      initialState?.envInfo?.enterpriseRoleCode === AppVersionList?.PREVIEW_ENV?.code ||
      initialState?.envInfo?.code === AppVersionList?.PREVIEW_ENV?.code
    ) &&
    initialState?.envInfo?.iyb !== 'Y';

  const handleApplyVersionTrial = () => {
    history.push('/versionTrial');
  };

  // if (!currentUser || !currentUser.account) {
  //   return loading;
  // }

  const menuItems = [
    // {
    //   key: 'licenseInfo',
    //   icon: <InfoCircleOutlined />,
    //   label: '授权信息',
    // },
    {
      key: 'center',
      icon: <InfoCircleOutlined/>,
      label: '个人中心',
    },
    {
      key: 'orderQuery',
      icon: <ShoppingCartOutlined/>,
      label: '订单查询',
    },
    {
      key: 'changePassword',
      icon: <SettingOutlined/>,
      label: '修改密码',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined/>,
      label: '退出登录',
    },
  ];

  const menuItems2 = [
    {
      key: 'changePassword',
      icon: <SettingOutlined/>,
      label: '修改密码',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined/>,
      label: '退出登录',
    },
  ];


  return (
    <>
      <Space
        style={{ marginRight: 10 }}
        onClick={() => {
          setAppDownloadModalShow(true);
        }}
      >
        <Popover content={'APP下载'}>
          <AppstoreOutlined style={{ fontSize: '20px' ,boxShadow: 'none', border: 'none', marginTop:'16px',marginRight: 10}} />
        </Popover>
      </Space>

      {initialState?.envInfo?.iyb !== 'Y' && (
        <Space
          style={{ marginRight: 10 }}
          onClick={() => {
            // setShowMessagePanelFlag(true);
            history.push('/oa/process/toAuditForm');
          }}
        >
          <Popover content={'系统通知'}>
            <Badge count={messageCount}  style={{   boxShadow: 'none', border: 'none', marginTop:'6px', padding: '0 4px' }}>
              <Avatar style={{ backgroundColor: 'transparent' }}>
                <div className={ `${workareaStyles.noticeService} custom-theme-icon `}  />
              </Avatar>
              {/*<span style={{ marginRight: 10 }}>系统通知</span>*/}
            </Badge>
          </Popover>
        </Space>
      )}

      <Space
        onClick={() => {
          ContactUtils.load();
          ContactUtils.showDialog();
          ContactUtils.openDialog();
        }}
      >
        {/*<span><Tag color="#346AFD">客服</Tag></span>*/}
        <Popover  content={'客服'}>
          <Avatar style={{ backgroundColor: 'transparent' }}>
            <div  className={ `${workareaStyles.customerService} custom-theme-icon ` }/>
          </Avatar>
        </Popover>
      </Space>

      <div>
        <Avatar shape="square" style={{ backgroundColor: 'transparent' }}>
          <div style={{ border:'1px solid transparent',  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ThemeSelector size="small" />
          </div>
        </Avatar>
      </div>

      {/*{*/}
      {/*  initialState?.currentUser && initialState?.currentUser.envInfo && initialState.currentUser.envInfo.code === 'PREVIEW_ENV' && (*/}
      {/*    <>*/}
      {/*      <Space onClick={() => {*/}
      {/*        history.push('/prepareEnv')*/}
      {/*      }}>*/}
      {/*        <span>环境升级</span>*/}
      {/*      </Space>*/}
      {/*      <Space onClick={() => {*/}
      {/*        history.push('/valueAdd')*/}
      {/*      }}>*/}
      {/*        <span>增值服务</span>*/}
      {/*      </Space>*/}
      {/*    </>*/}
      {/*}*/}
      {/*<Space onClick={() => {*/}
      {/*  setVisibleForCustomer(true);*/}
      {/*}}>*/}
      {/*  <span>功能定制</span>*/}
      {/*</Space>*/}
      {/*<Space onClick={() => {*/}
      {/*  setVisibleForCustomer(true);*/}
      {/*}}>*/}
      {/*  <span>联系客服</span>*/}
      {/*</Space>*/}

      {
        currentVersionName && initialState?.envInfo?.iyb !== 'Y' && (
          <Space size={8} style={{ marginLeft: 2, marginRight: 8 }}>
            {isFreeVersion && (
              <Button
                type="primary"
                size="small"
                onClick={handleApplyVersionTrial}
                style={{
                  height: 24,
                  padding: '0 10px',
                  borderRadius: 12,
                  fontSize: 12,
                  fontWeight: 500,
                }}
              >
                申请试用15天
              </Button>
            )}
            <span
              onClick={() => {
                setShowProfileFlag(true);
              }}
            >
              <Tag color={"#346AFD"} style={{ marginRight: 0 }}>{currentVersionName}</Tag>
            </span>
            {trialActive && (
              <Tag
                className={workareaStyles.trialStatusTag}
              >
                尊享版试用中，剩余 {trialRemainingDays} 天
              </Tag>
            )}
          </Space>
        )
        // : (
        //   <Space>
        //     <span><Tag color="#346AFD">正式环境</Tag></span>
        //   </Space>
        // )
      }

      {
        initialState?.envInfo?.iyb === 'Y' && (
          <Space onClick={() => {
            window.open('https://iswan.cc/edatlink-publicize', '_self');
          }}>
            <span><Tag color="#346AFD">开通 Edatlink AI</Tag></span>
          </Space>
        )
      }

      {
        initialState?.envInfo?.iyb === 'Y' ? (
          <HeaderDropdown
            menu={{
              selectedKeys: [],
              onClick: onMenuClick,
              items: menuItems2,
            }}
          >
            {children}
          </HeaderDropdown>
        ) : (
          <HeaderDropdown
            menu={{
              selectedKeys: [],
              onClick: onMenuClick,
              items: menuItems,
            }}
          >
            {children}
          </HeaderDropdown>
        )
      }

      {
        false ? (
          <div>
            <div onClick={() => {
              setCopilotOpen(true)
            }}
                 className={workareaStyles.headerButton}
            >
              ✨ AI 工具 New
            </div>
          </div>
        ) : null
      }


      <ChangePassword
        visible={visible}
        useInfo={currentUser}
        handleCancel={() => setVisible(false)}
        handleValue={async (val, form) => {
          const res = await resetPasswordForCurrent(val);
          console.log(122, res)
          form.resetFields();
          message.success('密码修改成功!');
        }}
      />

      <CustomerModal
        onSuccess={async () => {
          setVisibleForCustomer(false);
        }}
        onCancel={() => {
          setVisibleForCustomer(false);
        }}
        updateModalVisible={visibleForCustomer}
      />

      <AppDownloadModal show={appDownloadModalShow} closeFn={() => setAppDownloadModalShow(false)} />

      {
        showProfileFlag && (
          <Drawer
            width={1500}
            open={showProfileFlag}
            styles={{
              body: {
                padding: 0
              }
            }}
            title={'产品开通'}
            destroyOnHidden={true}
            maskClosable={false}
            keyboard={false}
            forceRender={true}
            onClose={() => {
              setShowProfileFlag(false);
            }}
            closable={true}
          >
            <PrepareEnv enterpriseId={initialState?.currentUser?.enterpriseId}
                        enterpriseName={initialState?.currentUser?.enterpriseName}
                        enterpriseCode={initialState?.currentUser?.enterpriseCode} fromPage={'customer'}/>
          </Drawer>
        )
      }
    </>
  );
};
